import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { v4 as uuidv4 } from 'uuid';

// Styles
import './styles/form-label-composer.scss';

const createWrapper = (Comp) =>
    class FormLabel extends PureComponent {
        static defaultProps = {
            disabled: false,
            isDisabled: false,
            readOnly: false,
            isReadOnly: false,
            isStacked: false,
            textIsAfterControl: false,
            showTextAfterControl: false,
        };

        static propTypes = {
            contextCls: PropTypes.string,
            labelText: PropTypes.string.isRequired,
            htmlFor: PropTypes.string,
            id: PropTypes.string,
            disabled: PropTypes.bool,
            isDisabled: PropTypes.bool,
            readOnly: PropTypes.bool,
            isReadOnly: PropTypes.bool,
            isStacked: PropTypes.bool,
            textIsAfterControl: PropTypes.bool,
            // TODO: Replace with 'shouldShowTextAfterControl'
            showTextAfterControl: PropTypes.bool,
            renderCustomLbl: PropTypes.func,
        };

        render() {
            const {
                contextCls,
                labelText,
                isStacked,
                disabled,
                isDisabled,
                htmlFor,
                renderCustomLbl,
                readOnly,
                isReadOnly,
            } = this.props;
            const shouldRenderTextOnRight = this.getShouldRenderTextOnRight();
            const modCls = {
                [`${this.baseCls}--disabled`]: isDisabled || disabled,
                [`${this.baseCls}--label-after`]: shouldRenderTextOnRight,
                [`${this.baseCls}--stacked`]: isStacked,
                [`${this.baseCls}--read-only`]: isReadOnly || readOnly,
            };

            return (
                <label
                    className={cx(this.baseCls, modCls, contextCls)}
                    htmlFor={htmlFor || this.id}
                >
                    {shouldRenderTextOnRight && this.renderComp()}
                    {renderCustomLbl ? (
                        this.renderCustomLbl()
                    ) : (
                        <span className={`${this.baseCls}__text`}>
                            <span className={`${this.baseCls}__text-inner`}>
                                {labelText}
                            </span>
                        </span>
                    )}
                    {!shouldRenderTextOnRight && this.renderComp()}
                </label>
            );
        }

        renderCustomLbl = () => {
            const { renderCustomLbl } = this.props;
            const customLblProps = { ...this.props };
            customLblProps.baseCls = this.baseCls;

            return renderCustomLbl(customLblProps);
        };

        renderComp() {
            const { id } = this.props;
            const compProps = { ...this.props };
            delete compProps.textIsAfterControl;
            delete compProps.showTextAfterControl;
            delete compProps.contextCls;
            delete compProps.labelText;
            delete compProps.isStacked;
            delete compProps.ariaLabel;
            delete compProps['aria-label'];
            delete compProps.htmlFor;
            compProps.id = id || this.id;

            return (
                <span className={`${this.baseCls}__comp-container`}>
                    <Comp {...compProps} />
                </span>
            );
        }

        getShouldRenderTextOnRight = () => {
            const {
                isStacked,
                showTextAfterControl,
                textIsAfterControl,
            } = this.props;

            return (showTextAfterControl || textIsAfterControl) && !isStacked;
        };

        baseCls = 'fluid-form-label';

        id = `fluid-form-el-${uuidv4()}`;
    };

const FormLabelComposer = createWrapper;

export default FormLabelComposer;
